import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, provider, database } from '../firebase';
import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                try {
                    const userSnap = await getDoc(doc(database, 'users', currentUser.uid));
                    if (userSnap.exists()) {
                        const ids = userSnap.data().projects || [];
                        const snaps = await Promise.all(ids.map(id => getDoc(doc(database, 'projects', id))));
                        setProjects(snaps.filter(d => d.exists()).map(d => ({ id: d.id, ...d.data() })));
                    }
                } catch (err) {
                    console.error('Error loading user projects:', err);
                }
            } else {
                setProjects([]);
            }
        });
        return () => unsubscribe();
    }, []);

    const handleLogin = async () => {
        try {
            await signInWithPopup(auth, provider);
        } catch (error) {
            alert('Login failed: ' + error.message);
        }
    };

    const handleLogout = async () => {
        await signOut(auth);
    };

    return (
        <AuthContext.Provider value={{ user, projects, handleLogin, handleLogout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
